
import { defineComponent } from "vue";
import { ToastFactory } from "@/utils/ToastFactory";
import { CoupomService } from "./coupom.service";
import TableViewBatch from "./TableViewBatch.vue";
import TableViewIndividual from "./TableViewIndividual.vue";
import {
  CoupomInterface,
  CoupomLotInterface,
} from "@/interfaces/Coupom.interface";
import { saveAs } from "file-saver";
const coupomService = new CoupomService();

export default defineComponent({
  name: "ListCoupons",
  components: { TableViewBatch, TableViewIndividual },
  data() {
    return {
      coupoms: [] as any,
      coupomsLot: [] as any,
      coupom: {} as CoupomInterface,
      coupomLot: {
        amountCoupon: 1 as number,
      } as CoupomLotInterface,
      dateExpiration: "" as string,
      amountCredit: 1 as number,
      viewType: "batch" as string,
      addIndivudual: false,
      params: { page: 0, size: 10, total: 0 },
      visible: false,
      loaderTable: false,
    };
  },
  methods: {
    paginate(event: { page: number; rows: number }) {
      this.setPage(event.page, event.rows);
    },

    setPage(page: number, size: number): void {
      this.loaderTable = true;
      if (this.viewType === "batch") {
        this.loaderTable = false;
        this.getCoupomLot(page, size);
      }
      if (this.viewType === "individual") {
        this.loaderTable = false;
        this.getCoupoms(page, size);
      }
    },

    async getCoupoms(page: number, size: number) {
      await coupomService.getCoupons({ page, size }).then((response: any) => {
        this.coupoms = response.content;
        this.params.total = response.total;
      });
    },

    async coupomPaginate(): Promise<void> {
      let page = this.params.page;
      let size = this.params.size;
      await this.getCoupomLot(page, size);
    },

    async getCoupomLot(page: number, size: number) {
      await coupomService.getCoupomLot({ page, size }).then((response: any) => {
        this.coupomsLot = response.content;
        this.params.total = response.total;
      });
    },

    async onChangeView(): Promise<void> {
      this.loaderTable = true;
      await setTimeout(() => {
        this.setPage(this.params.page, this.params.size);
      }, 500);
    },

    async sendCoupom(): Promise<void> {
      this.coupom.amountCredit = this.amountCredit;
      this.coupom.dateExpiration = this.dateExpiration;

      if (this.addIndivudual) {
        coupomService
          .createCoupon(this.coupom)
          .then(() => {
            this.$toast.add(
              ToastFactory.success(this.$t("toast.sucessCoupon"))
            );
            this.coupomPaginate();
            this.visible = false;
          })
          .catch(() => {
            this.$toast.add(ToastFactory.error(this.$t("toast.errorCoupon")));
          });
      } else {
        this.coupomLot.amountCredit = this.amountCredit;
        this.coupomLot.dateExpiration = this.dateExpiration;

        coupomService
          .createCoupomLot(this.coupomLot)
          .then(() => {
            this.$toast.add(ToastFactory.success(this.$t("toast.sucessLot")));
            this.coupomPaginate();
            this.visible = false;
          })
          .catch(() => {
            this.$toast.add(ToastFactory.error(this.$t("toast.errorLot")));
          });
      }
    },

    deleteCoupom(id: any) {
      coupomService
        .deleteCoupon(id)
        .then(() => {
          this.setPage(this.params.page, this.params.size);
          this.$toast.add(
            ToastFactory.success(this.$t("toast.sucessCouponDelete"))
          );
        })
        .catch(() => {
          this.$toast.add(
            ToastFactory.error(this.$t("toast.errorCouponDelete"))
          );
        });
    },

    deleteLot(id: any) {
      coupomService
        .deleteCoupomLot(id)
        .then(() => {
          this.setPage(this.params.page, this.params.size);
          this.$toast.add(
            ToastFactory.success(this.$t("toast.sucessLotDelete"))
          );
        })
        .catch(() => {
          this.$toast.add(ToastFactory.error(this.$t("toast.errorLotDelete")));
        });
    },

    async downloadCsvLot(event: any) {
      await coupomService.downloadCsvLot(event.id).then((response: any) => {
        const blob = new Blob([response], { type: "text/csv" });
        const url = window.URL.createObjectURL(blob);
        saveAs(url, `Lote_${event.name}.csv`);
      });
    },
  },
  mounted() {
    this.coupomPaginate();
  },
});
